// removed by extract-text-webpack-plugin
module.exports = {"carouselWrap":"qempo_CarouselCards_carouselWrap-1eUAJPX","carouselItem":"qempo_CarouselCards_carouselItem-SFZr27P","contentWrap":"qempo_CarouselCards_contentWrap-1iqUl3n","itemImage":"qempo_CarouselCards_itemImage-1Azl64l","itemText":"qempo_CarouselCards_itemText-2FQiQNG"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/shopping-cart/components/CarouselCards/CarouselCards.scss
// module id = 2269
// module chunks = 0